exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tagfound{\r\n  background: #2196F3;\r\n  color:#FFF;\r\n}\r\n\r\n.working{\r\n  background: #2574A9 !important;\r\n}\r\n\r\n.my-text-card{\r\n  color: #FFF !important;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.my-text-card option{\r\n  color: #000 !important;\r\n}\r\n\r\n.my-summary-text{\r\n  font-size: 1rem !important;\r\n}\r\n\r\n.my-card{\r\n  min-width: 160px;\r\n  max-width: 160px;\r\n  min-height: 280px;\r\n}\r\n\r\n.bg-blue{\r\n  background-color: #19B5FE;\r\n}\r\n\r\n.my-box{\r\n  width: 160px;\r\n}\r\n\r\n.my-icon{\r\n  padding: 0px !important;\r\n  margin: 0px !important;\r\n  height: 1rem !important;\r\n  vertical-align: middle !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/empaques/empaques.component.css
// module id = ../../../../../src/app/components/empaques/empaques.component.css
// module chunks = main